// biome-ignore lint/suspicious/noShadowRestrictedNames: <explanation>
import { Error } from '@/components/templates/Error/Error';
import { Error401 } from '@/feature/error/components/templates/Error401';
import { useAuth } from '@/providers/AuthProvider/useAuth';
import CircularProgress from '@mui/material/CircularProgress';
import { useLocation } from 'react-router';

const PUBLIC_PATHS = [
  '/privacy',
  '/terms',
  '/sign-in',
  '/sign-up',
  '/sign-up/personal/free',
  '/sign-up/personal/subscription',
  '/sign-up/personal/subscription/payment',
  '/sign-up/personal/success',
  '/sign-up/enterprise',
  '/sign-up/enterprise/owner',
  '/sign-up/enterprise/organization',
  '/admin/sign-in',
];

export const withAuthenticationRequired = <T extends Record<string, unknown>>(
  Component: React.FC<T>,
): React.FC<T> => {
  const ComponentWithAuthenticationRequired: React.FC<T> = (props) => {
    const { error, isLoading, isAuthenticated } = useAuth();
    const { pathname } = useLocation();

    if (isLoading) return <CircularProgress />;
    if (error !== null && error !== undefined) return <Error error={error} />;

    if (PUBLIC_PATHS.includes(pathname)) return <Component {...props} />;

    if (isAuthenticated) return <Component {...props} />;

    return <Error401 />;
  };

  return ComponentWithAuthenticationRequired;
};
